export default function exportChartWithLegend(svgElement, legendData, options = {}) {
    if (!svgElement) return console.error('svgElement is null');
  
    const {
      filename = 'chart.svg',
      backgroundColor = '#242424',
      borderColor = '#363636',
      borderWidth = 6,
      borderRadius = 14,
      legendSpacing = 24,
      legendDotRadius = 6,
      legendFontSize = 12,
      padding = 0 
    } = options;
  
    const svgNS = 'http://www.w3.org/2000/svg';
  
    const width = svgElement.viewBox?.baseVal?.width || svgElement.clientWidth;
    const height = svgElement.viewBox?.baseVal?.height || svgElement.clientHeight;
    const legendWidth = 140;
    const legendHeight = legendSpacing * legendData.length;
  
    const totalWidth = width + legendWidth + 16 * 5;
    const totalHeight = Math.max(height,legendHeight) + 16 * 2;
  
    const combinedSvg = document.createElementNS(svgNS, 'svg');
    combinedSvg.setAttribute('xmlns', svgNS);
    combinedSvg.setAttribute('width', totalWidth);
    combinedSvg.setAttribute('height', totalHeight);
  
    const background = document.createElementNS(svgNS, 'rect');
    background.setAttribute('x', 0);
    background.setAttribute('y', 0);
    background.setAttribute('width', totalWidth);
    background.setAttribute('height', totalHeight);
    background.setAttribute('rx', borderRadius);
    background.setAttribute('ry', borderRadius);
    background.setAttribute('fill', backgroundColor);
    background.setAttribute('stroke', borderColor);
    background.setAttribute('stroke-width', borderWidth);
    combinedSvg.appendChild(background);
  
    const chartGroup = document.createElementNS(svgNS, 'g');
    chartGroup.setAttribute('transform', `translate(${4}, ${4})`);
    chartGroup.innerHTML = svgElement.innerHTML;
    combinedSvg.appendChild(chartGroup);
  
    const legendGroup = document.createElementNS(svgNS, 'g');
    legendGroup.setAttribute(
      'transform',
      `translate(${width + 16}, ${16*3})`
    );
  
    legendData.forEach((item, i) => {
      const y = i * legendSpacing;
  
      const dot = document.createElementNS(svgNS, 'circle');
      dot.setAttribute('cx', 0);
      dot.setAttribute('cy', y);
      dot.setAttribute('r', legendDotRadius);
      dot.setAttribute('fill', item.color);
      legendGroup.appendChild(dot);
  
      const label = document.createElementNS(svgNS, 'text');
      label.setAttribute('x', legendDotRadius * 2 + 4);
      label.setAttribute('y', y + 4);
      label.setAttribute('font-size', 12);
      label.setAttribute('fill', '#7c7d7d');
      label.setAttribute('font-weight', 'bold');
      label.textContent = item.taskName;
      legendGroup.appendChild(label);
    });
  
    combinedSvg.appendChild(legendGroup);
  
    const svgString = new XMLSerializer().serializeToString(combinedSvg);
    const blob = new Blob([svgString], { type: 'image/svg_xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
  
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  }